export const LOAD_CHARAS_SUCCESS = 'LOAD_CHARAS_SUCCESS'
export const LOAD_CHARAS_LOADING = 'LOAD_CHARAS_LOADING'
export const LOAD_CHARAS_ERROR = 'LOAD_CHARAS_ERROR'